var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnplBlob(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 106,
    viewBox: "0 0 162 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.838 167.574C168.219 176.966 151.061 186.549 131.864 189.432C112.667 192.315 90.6963 186.91 80.141 171.711C71.858 159.785 72.0416 144.544 67.1788 131.084C55.3891 98.4502 15.7584 79.9737 3.56139 47.4693C-5.8474 22.3952 4.13418 -6.9261 24.7115 -25.3259C45.2888 -43.7254 74.8271 -51.8867 103.355 -51.0696C131.883 -50.2521 159.53 -41.1529 184.821 -28.8414L184.838 167.574Z",
    fill: "#DEE9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnplBlob);
export default __webpack_public_path__ + "static/media/bnpl-blob.b2c0b8ba7727033de3162d940283e9a2.svg";
export { ForwardRef as ReactComponent };